import { render, staticRenderFns } from "./backupNow.vue?vue&type=template&id=341b4206&"
import script from "./backupNow.vue?vue&type=script&lang=js&"
export * from "./backupNow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports